<template>
  <section class="w-100 mockup-section px-2">
    <h2 class="title text-center mb-5">{{ slice.primary.title1[0].text }}</h2>

    <b-row class="justify-content-md-center">
      <b-col
        ref="mockup-container"
        col
        md="10"
        lg="8"
        xl="6"
        class="position-relative p-0 mx-4 overflow-hidden mockup-col"
        :style="borderColor"
      >
        <div ref="effect-color" class="position-absolute color-effect h-100" :style="borderColor">
          <div class="h-100 w-100 overflow-hidden">
            <picture>
              <source
                v-for="{ resolution, size } in imageSizes"
                :key="resolution"
                :media="`(max-width: ${resolution}px)`"
                :srcset="`${slice.primary.end_image.url}&w=${size}&fmt=webp`"
              />
              <img
                :src="slice.primary.end_image.url"
                class="h-100 width-unset"
                :width="reservedWidth"
                :height="reservedHeight"
                loading="lazy"
              />
            </picture>
          </div>
          <div
            v-hammer:pan.all="(event) => onPan(event)"
            v-hammer:panend="onPanEnd"
            :class="switchClass"
            :style="backgroundColor"
          >
            <div class="switch-icons d-flex">
              <Icon icon="bootstrap-chevron-left" class="mx-1" :width="16" :height="16" />
              <Icon icon="bootstrap-chevron-right" class="mx-1" :width="16" :height="16" />
            </div>
          </div>
        </div>
        <picture>
          <source
            v-for="{ resolution, size } in imageSizes"
            :key="resolution"
            :media="`(max-width: ${resolution}px)`"
            :srcset="`${slice.primary.start_image.url}&w=${size}&fmt=webp`"
          />
          <img
            :src="slice.primary.start_image.url"
            class="w-100 h-100"
            :height="reservedHeight"
            :width="reservedWidth"
            loading="lazy"
          />
        </picture>
      </b-col>
    </b-row>
    <div class="row mx-0 w-100 d-flex justify-content-center align-items-center mt-5">
      <div class="button-mockup col-12 col-sm-6 justify-content-end">
        <Button
          class="mr-3"
          shape="full"
          :to="
            slice.primary.is_link_1_internal
              ? $trailingSlash(localePath(slice.primary.link_1[0].text))
              : slice.primary.link_1[0].text
          "
          :blank="!slice.primary.is_link_1_internal"
        >
          {{ slice.primary.button_1[0].text }}
        </Button>
      </div>
      <div class="button-mockup col-12 col-sm-6 justify-content-start">
        <Button
          class="ml-3"
          shape="full"
          :to="
            slice.primary.is_link_2_internal
              ? $trailingSlash(localePath(slice.primary.link_2[0].text))
              : slice.primary.link_2[0].text
          "
          :blank="!slice.primary.is_link_2_internal"
        >
          {{ slice.primary.button_2[0].text }}
        </Button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from 'UI/Icon';
import Button from 'UI/Button';
import Vue from 'vue';
if (process.browser) {
  const { VueHammer } = require('vue2-hammer');
  Vue.use(VueHammer);
}

export default {
  name: 'MockupSection',
  components: {
    Icon,
    Button
  },
  props: {
    slice: {
      type: Object,
      required: true
    },
    reservedHeight: {
      type: Number,
      required: false,
      default: 606
    },
    reservedWidth: {
      type: Number,
      required: false,
      default: 927
    }
  },
  data() {
    return {
      initialWidth: 0,
      imageSizes: [
        { resolution: 360, size: 280 },
        { resolution: 375, size: 320 },
        { resolution: 414, size: 384 },
        { resolution: 576, size: 495 },
        { resolution: 768, size: 685 },
        { resolution: 992, size: 800 },
        { resolution: 1200, size: 775 },
        { resolution: 1366, size: 664 },
        { resolution: 1536, size: 749 },
        { resolution: 1920, size: 941 }
      ]
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperienceColor']),
    borderColor() {
      return 'border-color: ' + this.getExperienceColor;
    },
    backgroundColor() {
      return 'background-color: ' + this.getExperienceColor;
    },
    switchClass() {
      var classList = [
        'switch',
        'position-absolute',
        'rounded-circle',
        'd-flex',
        'justify-content-center',
        'align-items-center'
      ];
      return classList.join(' ');
    }
  },
  mounted() {
    this.initialWidth = this.$refs['effect-color'].clientWidth;
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onPan(e) {
      if (e.type === 'panright' || e.type === 'panleft') {
        let absolute_width = e.deltaX + this.initialWidth;
        let percentage_width = (absolute_width * 100) / this.$refs['mockup-container'].clientWidth;
        if (percentage_width >= 0 && percentage_width <= 100)
          this.$refs['effect-color'].style.width = percentage_width + '%';
      }
    },
    onPanEnd() {
      this.initialWidth = this.$refs['effect-color'].clientWidth;
    },
    onResize() {
      this.initialWidth = this.$refs['effect-color'].clientWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.mockup-section {
  background-color: #f9f9f9;
  padding: 100px 0;
  @include sm {
    padding: 50px 0;
  }
  border-radius: 8px;
}
.button-mockup {
  display: flex;
  @include sm {
    span {
      margin: 0 !important;
    }
    justify-content: center !important;
    padding: 0 0 10px;
  }
}
.mockup-section > .title {
  font-size: 50px;
  font-weight: 500;
  @include md {
    font-size: 30px;
  }
}
.box {
  width: 25%;
  @include md {
    width: 50%;
  }
}
.box > .text-icon {
  font-size: 13px;
}
.box > .text-icon,
.box > span {
  font-weight: 500;
}
.mockup-col {
  border-style: solid;
  border-width: 2px;
  border-radius: 8px;
}
.color-effect {
  top: 0;
  left: 0;
  border-right-style: solid;
  border-right-width: 2px;
  width: 50%;
}
.switch {
  width: 60px;
  height: 60px;
  top: calc(50% - 30px);
  right: -30px;
  z-index: 3;
  @include md {
    width: 40px;
    height: 40px;
    top: calc(50% - 20px);
    right: -20px;
  }
}
.switch > .switch-icons {
  height: max-content;
  color: #ffffff;
}
.width-unset {
  width: unset;
}

.vx-custom-background {
  .mockup-section {
    background-color: #3a3a3a;
  }
  .title {
    color: #ffffff;
  }
}
</style>
